import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

import IframeWeb from './IframeWeb'
import { getUser } from './service/AuthService';

import './css/Notifications.css';

//TODO: move this to an environment variable
const notificationsUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/notifications';

const Notifications = () => {
    const user = getUser();
    const [message, setMessage] = useState('');
    const navigate = useNavigate()
    const [enabled, setEnabled] = useState(false);

    const toggleChange = () => {
        // Call API 
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            user: user,
            type: 'daily',
            enabled: !enabled
        }

        //console.log('calling API -- wooooo!')

        axios.post(notificationsUrl, requestBody, requestConfig).then(response => {
            //console.log('changed notification stuff:', response)
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setMessage(error.response.data.message);
            }
            else{
                setMessage('Sorry the server is down. Please try again later.');

            }
        })
        //console.log(JSON.stringify({ enabled: !enabled}))
        setEnabled(prev => !prev);
    }
    return (
        // <div className='wrapper' style={{ marginTop: '6.5rem' }}>
        //     <IframeWeb height="750" source="https://trampolinehealth.circle.so/home" />
        // </div>
        <div className='wrapper' style={{ marginTop: '6.5rem', marginLeft: '1.5rem', marginRight:' 1.5rem' }}>
            <div>
                <h2 className="text-center"> Consistency is Key in Longterm Behavior Change </h2>
            </div>
            <div className="container" style={{ marginTop: '2rem'}}>
                <div className="item" style={{ padding: '0' }}>
                    <h5> Notification Settings </h5>
                    <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"2.5rem" }}>
                        <div className="toggleee" style={{ display:'flex', flexDirection:'row', alignItems: 'center', justifyContent:"space-between" }}>
                            <div>
                                Daily Notifications
                            </div>

                            <label className="ios-toggle">
                                <input type="checkbox"
                                    checked={enabled}
                                    onChange={toggleChange} 
                                />
                                <span className="slider">
                                    <span className="handle"></span> 
                                </span>
                            </label>
                        </div>
                    </div>

                        {/* <div className="form-group"><label> Send a message: </label><br /> <input type="text" placeholder='question you have' value={message} onChange={event => setMessage(event.target.value)} /> <br /></div>
                        <div className="form-group"><input class="submit-bttn" type="submit" value="Submit" /><br /></div> */}
                </div>
            </div>
        </div>
)
}


export default Notifications;